import { HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { StorageKeys } from 'src/app/domain/enums/application/storage-keys.enum'
import { AuthUserCompany } from 'src/app/domain/models/application/auth-user-company.model'
import { environment } from 'src/environments/environment'

const API_URL = environment.apiURL
const BOREAL_URL = environment.borealURL
const PYANALITICS_URL = environment.pyAnaliticsURL

@Injectable({ providedIn: 'root' })
export class CompanyRepositoryService {
  private httpClient: HttpClient = inject(HttpClient)

  public setSelectedCompany(company: AuthUserCompany): void {
    sessionStorage.setItem(StorageKeys.KEY_COMPANY, JSON.stringify(company))
  }

  public setSelectedCompanyBranches(companyBranches: Array<number>): void {
    sessionStorage.setItem(StorageKeys.KEY_COMPANY_BRANCHES, companyBranches.toString())
  }

  public getSelectedCompany(): AuthUserCompany {
    return !!sessionStorage.getItem(StorageKeys.KEY_COMPANY) ? new AuthUserCompany(JSON.parse(sessionStorage.getItem(StorageKeys.KEY_COMPANY) as string)) : new AuthUserCompany()
  }

  public getSelectedCompanyBranches(): Array<number> {
    let selectedCompanyBranchesString: any

    if (sessionStorage.getItem(StorageKeys.KEY_COMPANY_BRANCHES)) selectedCompanyBranchesString = sessionStorage.getItem(StorageKeys.KEY_COMPANY_BRANCHES)?.split(',')
    else selectedCompanyBranchesString = new Array()

    let selectedCompanyBranchesNumber = selectedCompanyBranchesString.map((companyBranchId: any) => {
      return Number(companyBranchId)
    })

    return selectedCompanyBranchesNumber
  }

  public getAllUsers(companyId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${API_URL}/centralweb/custom/usuario/todos-usuarios-empresa/${companyId}`, { observe: 'response' })
  }

  public getIntegrations(): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${BOREAL_URL}/registration/integrations`, { observe: 'response' })
  }

  public getFinancialParameter(parentCompanyId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${API_URL}/centralweb/empresaparametrofinanceiro?$select=id,pedidoMisto,permiteAlterarMoeda,permiteMultiMoeda,visualizaPedido,visualizaProvisao,confTaxa/id,participanteObrigatorio,confTaxaPedido/id,operacaoRegraContabil/id,financeiroAntecipado,comissaoAtiva,vendedorObrigatorio,empresaContaPagamento/id,empresaContaRecebimento/id,recebimentoSomenteContaPadrao,pagamentoSomenteContaPadrao,filtroPedido&$filter=empresa/id eq ${parentCompanyId}`, { observe: 'response' })
  }

  public getAccountingParameter(parentCompanyId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${API_URL}/centralweb/empresaparametrocontabil?$select=visualizarContasAutomaticas&$filter=empresa/id eq ${parentCompanyId}`, { observe: 'response' })
  }

  public getParameter(companyId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${API_URL}/centralweb/empresa?$select=regimeTributario/id,cadCCusObrigatorio&$filter=id eq ${companyId}`, { observe: 'response' })
  }

  public getCompanyFinancialParameters(): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${BOREAL_URL}/parameters/company-financial-parameter`, { observe: 'response' })
  }

  public getCashFlowModel(companyId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${PYANALITICS_URL}/financeiro/dashboard/get-mascaras/${companyId}`, { observe: 'response' })
  }

  public getGroup(companyId: number, userId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${PYANALITICS_URL}/cadastro/getgroupempresas/${companyId}-${userId}`, { observe: 'response' })
  }

  public getMandatoryApportionment(parentCompanyId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${API_URL}/centralweb/custom/pedido/centro-de-custo-obrigatorio(${parentCompanyId})`, { observe: 'response' })
  }

  public getCertificateStatus(companyId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${BOREAL_URL}/company/certificate-status?companyId=${companyId}`, { observe: 'response' })
  }

  public getCompanyGeneralParameters(companyId: number): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${PYANALITICS_URL}/cadastro/parametros-empresa?empresaId=${companyId}`, { observe: 'response' })
  }

  public save(payload: Object): Observable<HttpResponse<any>> {
    return this.httpClient.post(`${BOREAL_URL}/company`, payload, { observe: 'response' })
  }

  public getCommonInformation(): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${BOREAL_URL}/company/common-information`, { observe: 'response' })
  }

  public exportExcel(): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${BOREAL_URL}/company/export`, { observe: 'response', responseType: 'blob' })
  }

  public getIdentityTypes(): Observable<HttpResponse<any>> {
    return this.httpClient.get(`${BOREAL_URL}/company/identities-type`, { observe: 'response' })
  }
}
